import React from "react";
import _ from "lodash";
import PropTypes from "prop-types";
import CryptoTool from "../../../utils/CryptoTool";
import API from "../../../utils/API";
import { addProductToCart, clearCart } from "../../../utils/shopifyUtils";
import { getMealsBreakdown, markNewMeals, bubbleUpSKU, calculateDeliveryDateFromNow, getSellingProgramSellingPlan, setDefaultUser } from "../../../utils/functions";
import {
  filterOutMeals,
  markExcluded,
  saveUserSelectionToLocalStorage,
  pushItemToCartObject,
  populateSKUs,
  groupExcludeCodes,
  markHidden,
  updateNavLink,
  getConstructorModeFromClient,
  populateMealsTitlesAndQuantities,
  populateMealsHandles,
  populateExcludedCodes,
  filterExcludeCodes,
  setSelectedMealsMark,
  getFLExcludes,
  getCMExcludes,
  // disableCareMealProducts,
} from "./utils";
import { logSentryError } from "../../../utils/sentryLogger";
import ContentWrap from "./../../organisms/ContentWrap";
import AddIns from "./../../organisms/AddIns";
import Sidebar from "./../../organisms/Sidebar";
import ProgressBarUncontrolled from "./../../molecules/ProgressBarUncontrolled";
import ContentInner from "./../../organisms/ContentInner";
import MealSettings from "../../organisms/MealSettings";
import MealList from "./../../organisms/MealList";
import SkeletonLoader from "./../../molecules/Skeleton";
import ErrorMessage from "./../../atoms/ErrorMessage";

const shopUrl = CryptoTool.getShopUrl();
const apiUrl = CryptoTool.getApiUrl();
const DefaultUser = CryptoTool.getDefaultUser();

class MealSelectorContent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoaded: false,
      step: 1,
      exclusions: [],
      diets: [],
      breakfasts: [],
      entrees: [],
      bundles: [],
      deliveryDate: "",
      additionals: [],
      selectedExclusions: [],
      selectedMeals: {
        breakfasts: [],
        entrees: [],
      },
      selectedAddIns: [],
      selectedDiet: "All diets",
      selectedProgram: "HF-Program",
      dietType: "Heart-Friendly Plan",
      cart: {
        products: [],
        bundles: [],
        cartQuantity: 0,
      },
      dietitian: { support: false, id: "", price: "" },
      limitations: {
        breakfastsMinLimit: 0,
        entreesMinLimit: 0,
        additionalMealsMinLimit: {
          breakfastsMinLimit: 0,
          entreesMinLimit: 0,
        },
      },
      charge: {},
      toCart: false,
      configPageUrl: "",
      sticky: false,
      compactHeader: false,
      programType: "",
      errorMessage: "",
    };

    this.lastScrollTop = 0;
    this.wrapRef = React.createRef();
    this.innerRef = React.createRef();
  }

  componentDidMount() {
    const { mode } = this.props;

    if (mode === "constructor") {
      this.getDataNewOrder();
    } else {
      this.getAccountModeData();
    }

    this.setState({
      deliveryDate: calculateDeliveryDateFromNow(),
    });
  }

  componentDidUpdate = (prevProps) => {
    const { mode } = this.props;
    if (mode !== "constructor") {
      if (prevProps.upcomingDeliveryMeals.length !== this.props.upcomingDeliveryMeals.length) {
        this.getAccountModeData();
      }
    }
  };

  async getDataNewOrder() {
    Promise.allSettled([await this.getProductsData(), await this.getBundlesData()]);
  }

  async getBundlesData() {
    const tag = this.state.constructorObject.dietType.split(" ")[0];
    setDefaultUser();

    const { id, email } = window.shopifyUser;
    const bundleUrl = CryptoTool.cryptUrl(shopUrl + "/api/products/bundles/diet?tag=" + tag + "&customer_id=" + id, email);

    try {
      let bundleData = await API.get(bundleUrl);
      bundleData = bundleData.data;
      this.setState({ bundles: bundleData });
    } catch (error) {
      this.setState({
        errorMessage: "No meals available",
        bundles: [],
      });
    }
  }

  async getProductsData() {
    const constructorObject = await getConstructorModeFromClient();
    this.setState({ constructorObject });
    let constructorData;
    const mealConstructorCollections = this.props.mealConstructorCollections;
    const mealSettings = this.props.mealSettings;
    const dietEnabled = mealSettings.diets;
    const addInsEnabled = mealSettings.addIns;

    setDefaultUser();
    const { id, email } = window.shopifyUser,
      mealCollectionId = mealConstructorCollections.mealsCollectionId,
      additionalCollectionId = mealConstructorCollections.additionalCollectionId,
      exclusionCollectionId = mealConstructorCollections.exclusionsCollectionId,
      dietCollectionId = mealConstructorCollections.dietsCollectionId;

    const productUrl = CryptoTool.cryptUrl(
      shopUrl +
        "/api/products?exclusionCollectionId=" +
        exclusionCollectionId +
        "&dietCollectionId=" +
        dietCollectionId +
        "&mealCollectionId=" +
        mealCollectionId +
        "&additionalCollectionId=" +
        additionalCollectionId +
        "&bundlesCollectionId=" +
        "&customer_id=" +
        id,
      email
    );

    try {
      constructorData = await API.get(productUrl);
      constructorData = constructorData.data;
    } catch (error) {
      constructorData = {
        exclusions: [],
        diets: [],
        meals: [],
        bundles: [],
        additionals: [],
      };
      this.setState({
        errorMessage: "Network error. Please, refresh the page.",
      });
    }

    let _diets = constructorData.diets;

    let _breakfasts = filterOutMeals(constructorData.meals, ["breakfast"], constructorObject.dietType);
    let _entrees = filterOutMeals(constructorData.meals, ["entrée"], constructorObject.dietType);
    const selectedMealsWithQ = setSelectedMealsMark(constructorObject.selectedMeals, constructorData, constructorObject);


    _diets.unshift({ id: "0", name: "All diets" });
    this.setState(
      {
        isLoaded: true,
        breakfasts: _breakfasts,
        entrees: _entrees,
        additionals: addInsEnabled === false ? [] : constructorData.additionals,
        exclusions: constructorData.exclusions,
        selectedExclusions: constructorObject.selectedExclusions,
        diets: dietEnabled === false ? [] : _diets,
        limitations: constructorObject.limitations,
        selectedDiet: constructorObject.selectedDiet,
        selectedProgram: constructorObject.selectedProgram,
        dietType: constructorObject.dietType,
        selectedAddIns: constructorObject.selectedAddIns,
        selectedMeals: selectedMealsWithQ,
        configPageUrl: constructorObject.configPageUrl,
        dietitian: constructorObject.dietitian,
        programType: constructorObject.programType,
      },
      () => {
        this.filterProductsWithExclusions();

        if (dietEnabled) {
          this.filterProductsWithDiet();
        }

        if (constructorObject.dietType !== "Low-FODMAP Plan") {
          updateNavLink(constructorObject.dietType);
        }
      }
    );
  }

  getAccountModeData = () => {
    const { additionals, exclusions, diets, charge, editSubscription, passedDownExlusions, upcomingDeliveryMeals, dietType } = this.props;
    let _charge = { ...charge };
    let dietTitle = _charge.main_title;
    const currentCharge = upcomingDeliveryMeals.filter((item) => _charge.addressId === item.addressId);

    const currentMeals = currentCharge[0].meals;
    const dietEnabled = window.mealSettings.diets;
    const addInsEnabled = window.mealSettings.addIns;

    let _breakfasts = filterOutMeals(currentMeals, ["breakfast"], dietTitle),
      _entrees = filterOutMeals(currentMeals, ["entrée"], dietTitle);
    let selectedBreakfasts = filterOutMeals(_charge.meals, ["breakfast"], dietTitle);
    let selectedEntrees = filterOutMeals(_charge.meals, ["entrée"], dietTitle);
    let selectedAddIns = filterOutMeals(_charge.meals, ["add-in"], dietTitle);
    let editedNewBreakfasts = editSubscription.breakfasts;
    let editedNewEntrees = editSubscription.entrees;

    this.setState(
      {
        isLoaded: true,
        exclusions: [...exclusions],
        diets: dietEnabled ? [...diets] : [],
        breakfasts: _breakfasts,
        entrees: _entrees,
        additionals: addInsEnabled ? [...additionals] : [],
        selectedExclusions: passedDownExlusions,
        selectedMeals: {
          breakfasts: [...selectedBreakfasts],
          entrees: [...selectedEntrees],
        },
        selectedAddIns: selectedAddIns,
        selectedDiet: "All meals",
        dietType: dietType,
        dietitian: { support: false, id: "", price: "" },
        limitations: {
          breakfastsMinLimit: editedNewBreakfasts,
          entreesMinLimit: editedNewEntrees,
          additionalMealsMinLimit: {
            breakfastsMinLimit: 0,
            entreesMinLimit: 0,
          },
        },
        charge: { ..._charge },
        configPageUrl: "",
        programType: "",
      },
      () => {
        this.filterProductsWithExclusions();
        /* this.filterCareMealProducts(); */
        if (dietEnabled) {
          this.filterProductsWithDiet();
        }
      }
    );
  };

  setQty = (obj, _obj) => {
    if (obj.id === _obj.id && obj.quantity > 0) {
      obj.quantity = _obj.quantity;
    }
  };

  saveMeals = (data, mode) => {
    this.setState(
      {
        selectedMeals: data,
      },
      () => {
        if (mode === "constructor") {
          saveUserSelectionToLocalStorage(this.state);
        }
      }
    );
  };

  handleMealChange = (item) => {
    const self = this;
    const { mode } = this.props;
    const _item = { ...item };

    let _newSelectedMeals = _.cloneDeep(this.state.selectedMeals),
      productType = _item.type === "breakfast" ? "breakfasts" : "entrees",
      mealExists = _newSelectedMeals[productType].findIndex((meal) => meal.id === _item.id);

    // if(this.state.dietType === "Care Plan") {
    //  const choosenTag = item.tags.find(tag => tag.includes("MCD"));
    //  this.filterCareMealProducts(choosenTag);
    // }

    if (mealExists >= 0) {
      _newSelectedMeals[productType].forEach(function (meal) {
        self.setQty(meal, _item);
      });
    } else {
      _newSelectedMeals[productType].push(_item);
    }
    _newSelectedMeals[productType] = _.remove(_newSelectedMeals[productType], (el) => el.quantity > 0);
    this.saveMeals(_newSelectedMeals, mode);
  };

  handleAddInsChange = (item) => {
    const self = this;
    const { mode } = this.props;
    const _item = { ...item };
    let newSelectedAddIns = [...this.state.selectedAddIns],
      mealExists = newSelectedAddIns.findIndex((meal) => meal.id === _item.id);

    if (mealExists >= 0) {
      newSelectedAddIns.forEach(function (meal) {
        self.setQty(meal, _item);
      });
    } else {
      newSelectedAddIns.push(_item);
    }

    newSelectedAddIns = _.remove(newSelectedAddIns, (data) => data.quantity > 0);

    newSelectedAddIns.forEach(function (meal) {
      let sku = meal.skuList.split(":")[0];
      meal.skuList = sku + ":" + meal.quantity;
    });
    this.saveMeals(newSelectedAddIns, mode);
  };


  handleExclusionChange = (e, reference) => {
    const { mode } = this.props;
    let newExlusions = [...this.state.selectedExclusions],
      change = reference.checked === true ? "add" : "delete",
      value = e.target.value;

    if (change === "add") {
      if (newExlusions.indexOf(value) === -1) {
        newExlusions.push(value);
      } else {
        _.remove(newExlusions, (item) => item === value);
      }
    } else {
      _.remove(newExlusions, (item) => item === value);
    }

    newExlusions = _.uniq(newExlusions);

    this.setState(
      {
        selectedExclusions: newExlusions,
      },
      () => {
        this.filterProductsWithExclusions(this.state);
        if (mode === "constructor") {
          saveUserSelectionToLocalStorage(this.state);
        }
      }
    );
  };

  handleDietChange = (e) => {
    const { mode } = this.props;
    this.setState(
      {
        selectedDiet: e.target.value,
      },
      () => {
        this.filterProductsWithDiet();
        if (mode === "constructor") {
          saveUserSelectionToLocalStorage(this.state);
        }
      }
    );
  };

  hadleClearAll = (e, type) => {
    let _selectedMeals = { ...this.state.selectedMeals };
    _selectedMeals[type] = [];

    this.setState({
      selectedMeals: _selectedMeals,
    });
  };

  handleDeleteItem = (id, type) => {
    const { mode } = this.props;
    let productType = type === "breakfast" ? "breakfasts" : "entrees",
      _selectedMeals = { ...this.state.selectedMeals },
      meals = _selectedMeals[productType];

    _.remove(meals, (item) => item.id === id);
    _selectedMeals[productType] = meals;

    this.saveMeals(_selectedMeals, mode);
  };

  handleDietitianChange = (e) => {
    const { mode } = this.props;
    this.setState(
      {
        dietitian: {
          support: e.checked,
          id: e.value,
          price: this.state.dietitian.price,
        },
      },
      () => {
        if (mode === "constructor") {
          saveUserSelectionToLocalStorage(this.state);
        }
      }
    );
  };

  handleCompactModeClick = () => {
    this.setState({
      compactHeader: !this.state.compactHeader,
    });
  };

  filterProductsWithDiet = () => {
    let _breakfasts = [...this.state.breakfasts],
      _entrees = [...this.state.entrees],
      _diets = [...this.state.diets],
      _diet = this.state.selectedDiet,
      _filteredOutDiets = [];

    _filteredOutDiets = _diets.map((diet) => _diet !== diet.name && _diet !== "None");

    let breakfastsMarked = markHidden(_breakfasts, this.state);
    let entreesMarked = markHidden(_entrees, this.state);
    this.setState({
      breakfasts: breakfastsMarked,
      entrees: entreesMarked,
    });
  };

  filterProductsWithExclusions = () => {
    let _breakfasts = [...this.state.breakfasts],
      _entrees = [...this.state.entrees],
      _selectedBreakfasts = [...this.state.selectedMeals.breakfasts],
      _selectedEntrees = [...this.state.selectedMeals.entrees],
      _selectedExclusions = [...this.state.selectedExclusions];

    let breakfastsMarked = markExcluded(_breakfasts, _selectedExclusions),
      entreesMarked = markExcluded(_entrees, _selectedExclusions),
      userBreakfastsMarked = markExcluded(_selectedBreakfasts, _selectedExclusions),
      userEntreesMarked = markExcluded(_selectedEntrees, _selectedExclusions);

    this.setState({
      breakfasts: breakfastsMarked,
      entrees: entreesMarked,
      selectedMeals: {
        breakfasts: userBreakfastsMarked,
        entrees: userEntreesMarked,
      },
    });
  };

  // filterCareMealProducts = (tag) => {
  //   let _breakfasts = [...this.state.breakfasts],
  //     _entrees = [...this.state.entrees];

  //   let breakfastsMarked = disableCareMealProducts(_breakfasts, tag),
  //     entreesMarked = disableCareMealProducts(_entrees, tag);

  //   this.setState({
  //     breakfasts: breakfastsMarked,
  //     entrees: entreesMarked,
  //   });
  // };

  handleCTAClick = () => {
    const { mode } = this.props;

    if (mode === "constructor") {
      const { additionals } = this.state;
      if (!additionals.legnth) {
        this.handleToCheckoutClick(true);
      } else {
        this.setState({
          step: 2,
        });
      }
    } else {
      const { additionals } = this.props;
      if (!additionals.legnth) {
        this.handleSaveCharge();
      } else {
        this.setState({
          step: 2,
        });
      }
    }
  };

  handleBackClick = () => {
    this.setState({
      step: 1,
    });
  };

  handleToCheckoutClick = (clearCartFlag) => {
    let _cart = { ...this.state.cart },
      deliveryDate = calculateDeliveryDateFromNow(),
      dietType = this.state.dietType,
      _bundles = this.state.bundles,
      _exclusions = [...this.state.exclusions],
      _selectedExclusions = [...this.state.selectedExclusions],
      breakfasts = [...this.state.selectedMeals.breakfasts],
      entrees = [...this.state.selectedMeals.entrees],
      _selectedAddIns = this.state.selectedAddIns.map((addIn) => {
        addIn.id = addIn.variants[0].id;
        return addIn;
      }),
      breakfastsQantity = 0,
      entreesQantity = 0,
      breakfastsSKUs = "",
      entreesSKUs = "",
      breakfastsMealsItemTitles = "",
      entreesMealsItemTitles = "",
      breakfastsMealsItemHandles = "",
      entreesMealsItemHandles = "",
      productsToAdd = [],
      dietitianItem = {
        id: this.state.dietitian.id,
        title: "Dietitian",
        selling_plan: getSellingProgramSellingPlan(this.state.dietType),
        quantity: 1,
      };
console.log('dietitianItem', dietitianItem);

    let exclusionSkuPrefix;

    if (getFLExcludes(this.state.dietType)) {
      exclusionSkuPrefix = "FL-";
    } else if (getCMExcludes(this.state.dietType)) {
      exclusionSkuPrefix = "CM-";
    } else {
      exclusionSkuPrefix = "MD-";
    }


    let { excludeCodes, freshLean } = populateExcludedCodes(_exclusions, _selectedExclusions, exclusionSkuPrefix);

    breakfasts.forEach((item) => {
      breakfastsQantity += item.quantity;
    });

    entrees.forEach((item) => {
      entreesQantity += item.quantity;
    });

    breakfastsSKUs = populateSKUs(breakfasts);
    entreesSKUs = populateSKUs(entrees);

    breakfastsMealsItemTitles = populateMealsTitlesAndQuantities(breakfasts);
    entreesMealsItemTitles = populateMealsTitlesAndQuantities(entrees);
    breakfastsMealsItemHandles = populateMealsHandles(breakfasts);
    entreesMealsItemHandles = populateMealsHandles(entrees);

    pushItemToCartObject({
      data: _bundles,
      type: "Breakfasts",
      quantity: breakfastsQantity,
      SKUs: breakfastsSKUs,
      mealTitles: breakfastsMealsItemTitles,
      handles: breakfastsMealsItemHandles,
      excludeCodes: excludeCodes,
      freshLean: freshLean,
      targetArray: productsToAdd,
    });
    pushItemToCartObject({
      data: _bundles,
      type: "Entrees",
      quantity: entreesQantity,
      SKUs: entreesSKUs,
      mealTitles: entreesMealsItemTitles,
      handles: entreesMealsItemHandles,
      excludeCodes: excludeCodes,
      freshLean: freshLean,
      targetArray: productsToAdd,
    });
console.log('productsToAdd', productsToAdd);

    _cart.bundles = productsToAdd;
    _cart.cartQuantity = breakfastsQantity + entreesQantity;
    if (!clearCartFlag) {
      productsToAdd = _.concat(productsToAdd, _selectedAddIns);
    }
   console.log('this.state.dietitian.support', this.state.dietitian.support);

    if (this.state.dietitian.support) {
      _cart.products.dietitian = dietitianItem;
      productsToAdd.push(dietitianItem);
    }

    productsToAdd.reverse();

    _cart.products = [...productsToAdd];

    this.setState(
      {
        cart: _cart,
      },
      function () {
        clearCart(function () {
          return addProductToCart({ productsToAdd, deliveryDate, dietType });
        });
      }
    );
  };

  handlePrevClick = () => {
    this.props.handlePrevClick();
  };

  handleClickEditQuantity = () => {
    this.props.handleClickEditQuantity();
  };

  handleSaveCharge = () => {
    const { selectedAddIns, selectedExclusions, selectedMeals } = this.state;
    const { customerId, redirectEditQuantity, charge, exclusions, main_title } = this.props;
    const meals = _.concat(selectedMeals.breakfasts, selectedMeals.entrees, selectedAddIns);
    let _charge = { ...charge };

    const filteredExcludeCodes = filterExcludeCodes(exclusions, selectedExclusions);

    const addressId = _charge.addressId;

    let exclusionSkuPrefix;

    if (typeof main_title !== "undefined") {
      exclusionSkuPrefix = getFLExcludes(main_title) ? "FL-" : getCMExcludes(main_title) ? "CM-" : "MD-";
    } else {
      exclusionSkuPrefix = getFLExcludes(this.state.dietType) ? "FL-" : getCMExcludes(this.state.dietType) ? "CM-" : "MD-";
    }

    const excludeCodes = groupExcludeCodes(filteredExcludeCodes, exclusionSkuPrefix);
    const mealsBreakdown = getMealsBreakdown(_charge.meals);
    const savedMealsBreakdown = getMealsBreakdown(meals);

    let newMeals = markNewMeals(mealsBreakdown, savedMealsBreakdown, meals, _charge.meals);

    newMeals = bubbleUpSKU(newMeals);

    const url = `${apiUrl}/api/customers/${customerId}/upcomingDeliveries`;
    const customerEmail = window.theme.customerEmail;
    const data = {
      excludeCodes: excludeCodes,
      addressId: addressId,
      editedByUser: true,
      meals: newMeals,
    };

    API.post(CryptoTool.cryptUrl(url, customerEmail, true), data)
      .then(() => {
         if (typeof redirectEditQuantity === "undefined" || redirectEditQuantity === false) {
          window.location.href = window.location.href.split("?")[0]; //Redirect to Edit Delivery
        } else {
          window.location.href = window.location.origin + "/pages/account-settings"; //Redirect to Account Settings
        }
      })
      .catch((error) => {
        this.setState({
          errorMessage: error.message,
        });
        logSentryError(error);
      });
  };

  render() {
    const {
      isLoaded,
      bundles,
      exclusions,
      breakfasts,
      entrees,
      additionals,
      diets,
      selectedMeals,
      selectedAddIns,
      selectedExclusions,
      selectedDiet,
      dietType,
      toCart,
      limitations,
      configPageUrl,
      dietitian,
      sticky,
      compactHeader,
      programType,
      step,
      charge,
      errorMessage,
      selectedProgram,
    } = this.state;

    const { mode, mealSettings, main_title } = this.props;
    return (
      <>
        {errorMessage && (
          <ErrorMessage
            modalIsOpen={errorMessage.length ? true : false}
            closeErrorModal={this.handleCloseErrorModal}
            message={errorMessage}
          />
        )}
        {mode === "constructor" && (
          <ProgressBarUncontrolled
            selectedMeals={selectedMeals}
            selectedAddIns={selectedAddIns}
            bundles={bundles}
            programType={programType}
            selectedDiet={selectedDiet}
            dietType={dietType}
            dietitian={dietitian}
            step={step}
            limitations={limitations}
          />
        )}
        {step === 1 && (
          <ContentWrap mode={mode}>
            <ContentInner>
              <MealSettings
                exclusions={exclusions}
                diets={diets}
                exclusionChange={this.handleExclusionChange}
                selectedExclusions={selectedExclusions}
                selectedDiet={selectedDiet}
                dietChange={this.handleDietChange}
                sticky={sticky}
                handleCompactModeClick={this.handleCompactModeClick}
                compactHeader={compactHeader}
                mode={mode}
                main_title={main_title}
              />
              <div>
                {breakfasts.length > 0 || entrees.length > 0 ? (
                  <MealList
                    breakfasts={breakfasts}
                    entrees={entrees}
                    handleMealChange={this.handleMealChange}
                    selectedMeals={selectedMeals}
                    limitations={limitations}
                    selectedDiet={selectedDiet}
                    compactHeader={compactHeader}
                    mode={mode}
                    handlePrevClick={this.handlePrevClick}
                    charge={charge}
                    configPageUrl={configPageUrl}
                    dietType={dietType}
                    main_title={main_title}
                  />
                ) : (
                  <SkeletonLoader />
                )}
              </div>
            </ContentInner>
            <Sidebar
              isLoaded={isLoaded}
              selectedMeals={selectedMeals}
              selectedExclusions={selectedExclusions}
              selectedDiet={selectedDiet}
              dietType={dietType}
              handleMealChange={this.handleMealChange}
              hadleClearAll={this.hadleClearAll}
              handleDeleteItem={this.handleDeleteItem}
              toCart={toCart}
              handleCTAClick={this.handleCTAClick}
              limitations={limitations}
              selectedProgram={selectedProgram}
              configPageUrl={configPageUrl}
              dietitian={dietitian}
              handleDietitianChange={this.handleDietitianChange}
              sticky={sticky}
              compactHeader={compactHeader}
              mode={mode}
              handlePrevClick={this.handlePrevClick}
              charge={charge}
              programType={programType}
              mealSettings={mealSettings}
              handleClickEditQuantity={this.handleClickEditQuantity}
              main_title={main_title}
            />
          </ContentWrap>
        )}
        {/* <AddIns doesn't exist on April 2023 */}
        {step === 2 && (
          <ContentWrap>
            <AddIns
              additionals={additionals}
              handleBackClick={this.handleBackClick}
              handleToCheckoutClick={this.handleToCheckoutClick}
              selectedAddIns={selectedAddIns}
              handleMealChange={this.handleAddInsChange}
              handleSaveCharge={this.handleSaveCharge}
              mode={mode}
            />
          </ContentWrap>
        )}
      </>
    );
  }
}

MealSelectorContent.propTypes = {
  customerId: PropTypes.number,
  mealConstructorCollections: PropTypes.object,
  mode: PropTypes.string,
  mealSettings: PropTypes.object,
};

export default MealSelectorContent;
